import { Feature } from "@core/enums";

import { SidebarNavigationItemProps } from "./components";

export const navigationItems: SidebarNavigationItemProps[] = [
  {
    icon: "house",
    name: "Dashboard",
    to: "/",
    features: Feature.Dashboard,
  },
  {
    icon: "book",
    name: "Learning",
    to: "/courses",
    features: [
      Feature.Learning_MyCourses,
      Feature.Learning_Courses_Active__Inactive,
    ],
  },
  {
    icon: "book",
    name: "Learning v2",
    to: "/courses-v2",
    features: [
      Feature.CourseManagementLearn,
      Feature.CourseManagementReadAll,
      Feature.CourseManagementReadAssigned,
      Feature.CourseManagementGradeAll,
      Feature.CourseManagementGradeAssigned,
      Feature.CourseManagementTemplate,
      Feature.CourseManagementAssignUser,
    ],
  },
  {
    icon: "bell",
    name: "Notifications",
    to: ["/requests", "/requests-history"],
    features: Feature.Requests,
  },
  {
    icon: "bug",
    name: "Hangfire",
    to: "/hangfire",
    features: Feature.Hangfire_Dashboard,
  },
];
